import { useEffect } from "react";
export default (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            if (Array.isArray(ref)) {
                const isTargetInside = ref.some((refItem) => !refItem.current ||
                    refItem.current.contains(event.target));
                if (isTargetInside)
                    return;
            }
            else if (!ref.current ||
                ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler]);
};
//# sourceMappingURL=useClickOutside.js.map